


(function($, B) {
    'use strict';
 
    B.web.toInit['sticky'] = true;
    B.web.widgets['sticky'] = {
        enabled: false,
        selectors: {
            sticky: '.sticky-element'
        },
        $elements:{
        },
        data:{
            offsetTop: 0,
            stickyHeight: 0
        },
        init:function(){
            Bajt.web.getElements(this.selectors, this.$elements);
            if(this.$elements.sticky){
                this.enabled = true;
                this.$elements['next'] = this.$elements.sticky.next();
                this.data.offsetTop = this.$elements.sticky.offset().top;
                this.data.nextTopPadding = parseInt(this.$elements.next.css('margin-top'));
                this.bind();
            }
        },
        setNextTopPadding:function(sticky){
            this.$elements.next.css('margin-top', ( sticky ? this.data.stickyHeight : 0 ) + this.data.nextTopPadding);
        },
        stick:function(){
            this.$elements.sticky.addClass('sticky');
            this.data.stickyHeight = this.$elements.sticky.outerHeight( true );
            this.setNextTopPadding(true);
            var kk= 1;
            // this.$elements.next.p
        },
        unStick:function(){
            this.$elements.sticky.removeClass('sticky');
            this.setNextTopPadding();
        },
        bind:function(){
            var that = this;
            $(window).on('scroll', function(){
                that[window.pageYOffset >= that.data.offsetTop ? 'stick' : 'unStick']();
            });
        }
    };
})(jQuery, Bajt);



(function($, B) {




    $(document).ready(function() {       
        var $body = $('body');


        $('.paroller').paroller();

        $('.lazy').Lazy({
            // your configuration goes here
            scrollDirection: 'vertical',
            effect: 'fadeIn',
            visibleOnly: true,
            onError: function(element) {
                console.log('error loading ' + element.data('src'));
            }
        });
                  
        $body
        .on('click', '[data-toggle-details]', function() {
            var $this = $(this),
                type = String($this.data('toggle-details')),
                target = $this.data('target'), 
                expanded = $this.attr('data-expanded') === '1' ? true : false,
                fn = expanded ? 'slideUp' : 'slideDown' ,
                _fnCallBack = expanded 
                    ? function(){
                        $(this).removeClass('show');
                    }
                    : function(){
                        $(this).addClass('show');
                    },
                $container;    

            switch(type){
                case 'all':
                    $container = $body;
                break;
                case 'childs':
                    $container = $this;
                break;
                default:
                    $container = $this.closest(type);
            }
            if(type === 'childs'){
                $container.children(target)[fn](_fnCallBack);
            }else{
                $container.find(target)[fn](_fnCallBack);
            }
            // $this.attr('data-expanded', !expanded);
            var ll=$container.find('[data-target="' + target + '"]');
            $container.find('[data-target="' + target + '"]').each(function(){
                var $this=$(this),
                    o=$this.data();
                if(Array.isArray(o.icons)){
                    $this.changeIcon(o.icons[expanded ? 0 : 1]);
                }
                $this.attr('data-expanded', expanded ? '0' : '1');
            });
        })
        .on('click', '[data-show-child]', function() {
            var $this = $(this),
                $rowpos = $this.closest('.row-pos'),
                show = $this.data('show-child');
            if (show) {
                if (show === '1') {
                    $rowpos.children('.row-child').slideToggle();
                } else if (show === 'all') {
                    $('.row-child').slideToggle();
                } else {
                    $rowpos
                        .closest('.' + show)
                        .find('.row-child.' + show)
                        .slideToggle();
                }
            }
        })
        .on('change', '[data-content-filter]', function(){
            var $filter=$(this),
                o=$filter.data(),
                $container = $(o.container), 
                value=$filter.find('input[type=radio]:checked').val();
            if(value === 'all'){
                $container.find(o.contentFilter+':hidden').slideDown('fast');
            }else{
                $container.find('#'+value+':hidden').slideDown('fast');
                $container.find(o.contentFilter+':not(#'+value+'):visible').slideUp('fast');
            }
        })
        ;
    });
    





})(jQuery, Bajt);